import { useState, useEffect } from 'react'
export const MOBILE = 768

export default function useWindowSize () {
  const isSSR = typeof window === 'undefined'
  const [windowSize, setWindowSize] = useState({
    width: isSSR ? 450 : window.innerWidth,
    height: isSSR ? 400 : window.innerHeight,
    isMobile: isSSR ? false : window.innerWidth <= MOBILE
  })
  useEffect(() => {
    let frame = null
    const handleResize = () => {
      if (frame) return
      frame = window.requestAnimationFrame(() => {
        frame = null
        setWindowSize(prev => {
          const width = window.innerWidth
          const height = window.innerHeight
          if (prev.width === width && prev.height === height) return prev
          return { width, height, isMobile: width <= MOBILE }
        })
      })
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [])
  return windowSize
}
